module.exports = __webpack_public_path__ + "img/19.a8efbb12.svg";